import { isValid, parseISO } from "date-fns";

const calendarDay = (date: Date) => {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "Asia/Kolkata", year: "numeric", month: "numeric", day: "numeric" }).formatToParts(date);
  const part = (type: string) => Number(parts.find((value) => value.type === type)?.value);
  return Date.UTC(part("year"), part("month") - 1, part("day"));
};

export const subscriptionDaysRemaining = (endDate: string, now = new Date()) => {
  const date = parseISO(endDate || "");
  return isValid(date) ? Math.round((calendarDay(date) - calendarDay(now)) / 86400000) : null;
};

export const subscriptionCurrency = (amount?: number | null) =>
  typeof amount === "number" && Number.isFinite(amount)
    ? new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(amount)
    : "Not recorded";

export const subscriptionDate = (value?: string | null) => {
  const date = parseISO(value || "");
  return isValid(date) ? new Intl.DateTimeFormat("en-US", { timeZone: "Asia/Kolkata", month: "short", day: "2-digit", year: "numeric" }).format(date) : "Not recorded";
};

export const subscriptionDuration = (program: string, custom?: number) =>
  program === "custom" ? (custom ? `${custom} ${custom === 1 ? "day" : "days"}` : "Custom duration") : program || "Not recorded";

export const subscriptionOrderItems = (order: {
  mealId?: { name?: string } | null;
  meals?: Array<{ mealId?: { name?: string } | null }>;
  drinkId?: { name?: string } | null;
  drinks?: Array<{ drinkId?: { name?: string } | null }>;
}) => {
  const meals = order.meals?.length ? order.meals.map((item) => item.mealId?.name || "Meal details unavailable") : order.mealId ? [order.mealId.name || "Meal details unavailable"] : [];
  const drinks = order.drinks?.length ? order.drinks.map((item) => item.drinkId?.name || "Drink details unavailable") : order.drinkId ? [order.drinkId.name || "Drink details unavailable"] : [];
  return [...meals, ...drinks].join(" + ") || "Menu not assigned";
};
